var BxfTabBarDeletableTypeEnum;
(function (BxfTabBarDeletableTypeEnum) {
    BxfTabBarDeletableTypeEnum["DELETABLE_ADDABLE"] = "deletable-addable";
    BxfTabBarDeletableTypeEnum["DELETABLE"] = "deletable";
})(BxfTabBarDeletableTypeEnum || (BxfTabBarDeletableTypeEnum = {}));

export { BxfTabBarDeletableTypeEnum as B };
